import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames';

class FlexLayoutBox extends PureComponent {
  render() {
    const { className, header, secondaryHeader, children, testid, noBodyPadding } = this.props;

    const fullHeader = secondaryHeader ? (
      <div className="flex-layout__box-header-with-secondary">
        <div>{header}</div>
        <div className="h_mstart-a">{secondaryHeader}</div>
      </div>
    ) : (
      <div className="flex-layout__box-header">{header}</div>
    );

    /*
		In order to guarantee that passing in a class will overwrite the flex defaults, we had to have these defaults as a separate class that is only applied if the user does NOT pass in a class. We want the styling applied to all boxes consistently however, so this is separately applied to all box divs.
		*/
    return (
      <div
        data-testid={testid}
        className={classNames('flex-layout__box-styling', {
          [className]: !!className,
          'flex-layout__box-flex-default': !className,
        })}
      >
        {header ? fullHeader : null}
        <div className={classNames({ 'h_p-20': !noBodyPadding })}>{children}</div>
      </div>
    );
  }
}

FlexLayoutBox.propTypes = {
  /**
   * This class will be added to the box container div, replacing the default flex box class from being added (default is flex-grow and flex-shrink both at 1 (evenly spaced), and flex-basis to 0 (meaning all space is distributed, not just extra space as with 'auto')). The default box styling will apply regardless of whether a className is passed as a prop or not - set to 6px margins all around (so adds to 12px between each adjacent box). The flex container automatically has -6px margins, so the boxes touching the container (either right-left or top-bottom) will be flush with the container edges by default.
   */
  className: PropTypes.string,
  /**
   * Title section header will appear if passed in, no header if not. The padding above and below the box content will be 10px if there is a title, and 20px if there is not.
   */
  header: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  /**
   * set on container <div/> as data-testid attr for QA
   */
  testid: PropTypes.string,
};

// NOTE: Must be used as child of FlexLayoutContainer to work properly.

export default FlexLayoutBox;
